import type { SparkleIconProps } from './SparkleIcon';
import { SparkleIcon } from './SparkleIcon';

export type QuickActionSparkIconProps = SparkleIconProps;

/** @deprecated Use `SparkleIcon` — brand-aware (AG purple / HID blue). */
export function QuickActionSparkIcon(props: QuickActionSparkIconProps) {
  return <SparkleIcon {...props} />;
}
